/**
 * stageDotFor.ts — the ONE lookup from a stage label to its colour (Home tabs
 * H-1b, RULED 2026-10-18: one stage colour everywhere): stageDot by the
 * verbatim label — the Pipeline board's own map — and the neutral dot for a
 * label the map does not know, never a borrowed real-stage colour. Shared by
 * DealStageBadge (DashboardShared.tsx), the Home donut and the Reports stage
 * rows (funnelRows.ts), so a stage reads the same colour on every screen.
 * Its own file so the component module exports components only
 * (react-refresh/only-export-components).
 */
import { neutral, stageDot } from '../../theme/tokens'

export function stageDotFor(stage: string): string {
  return (stageDot as Record<string, string>)[stage] ?? neutral.dot
}
